import { render, staticRenderFns } from "./NotesComponents.vue?vue&type=template&id=779c6b0a&"
import script from "./NotesComponents.vue?vue&type=script&lang=js&"
export * from "./NotesComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports